<template>
  <div
    class="exitWrapper"
    :class="{ small: isSmall }"
    @click="$emit('closeEvent')"
  >
    <v-icon
      name="times"
      scale="2"
      color="#aaaaaa"
      alt="Dark close icon"
      v-if="dark"
    ></v-icon>
    <v-icon
      name="times"
      scale="2"
      color="#ffffff"
      alt="Dark close icon"
      v-else
    ></v-icon>
    <!-- <img src="@/assets/closeIconDark.svg" alt="Dark close Icon" v-if="dark">
        <img src="@/assets/closeIcon.svg" alt="Close Icon" v-else> -->
  </div>
</template>
<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.exitWrapper {
  width: 60px;
  height: 60px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.exitWrapper img {
  width: 30px;
  height: 30px;
}

.small img {
  width: 20px;
  height: 20px;
}
</style>
